import { create } from 'zustand';
import { IActiveItem } from '../models/modules';
import { persist } from 'zustand/middleware';
import { ISubject } from '../../../core/models/subject';

export type SubjectContentType =
  | 'videoaula'
  | 'exercicio'
  | 'material'
  | 'podcast';

interface SubjectState {
  subjects: ISubject[] | null;
  active: IActiveItem | null; //Modulo ativo
  subject: ISubject | null;
  isLoading: boolean;
  contentType: SubjectContentType;
  _hasHydrated: boolean | null;
  setActive: (module: IActiveItem | null) => void;
  setSubjects: (subject: ISubject[]) => void;
  setSubject: (item: ISubject | null) => void;
  setIsLoading: (loading: boolean) => void;
  setHasHydrated: (hydrate: boolean) => void;
  setContentType: (contentType: SubjectContentType) => void;
  resetSubject: () => void;
}

export const useSubjectStore = create<SubjectState>()(
  persist(
    (set) => ({
      subjects: null,
      active: null,
      subject: null,
      isLoading: false,
      contentType: 'videoaula',
      _hasHydrated: false,
      setActive: (module: IActiveItem | null) => set({ active: module }),
      setSubjects: (subjects: ISubject[]) => set({ subjects: subjects }),
      setSubject: (item: ISubject | null) => set({ subject: item }),
      setIsLoading: (loading: boolean) => set({ isLoading: loading }),
      setHasHydrated: (hydrate: boolean) => set({ _hasHydrated: hydrate }),
      setContentType: (contentType: SubjectContentType) =>
        set({ contentType: contentType }),
      resetSubject: () =>
        set({
          subjects: null,
          active: null,
          subject: null,
          isLoading: false,
          _hasHydrated: false,
        }),
    }),
    {
      name: 'discipline-subject',
      onRehydrateStorage: () => (state) => {
        state && state.setHasHydrated(true);
      },
    }
  )
);
